module.exports = __webpack_public_path__ + "media/images/icons/briefcase-d1c1b005922419c6013a2a17246843b8.svg";